import { render, staticRenderFns } from "./_navbar.vue?vue&type=template&id=2a142496&scoped=true"
import script from "./_navbar.vue?vue&type=script&lang=js"
export * from "./_navbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a142496",
  null
  
)

export default component.exports